import React from 'react';
import SVGIcon from '../../components/SVGIcon';
import informationIcon from '../../icons/information.svg';
import styles from './AnnotationLink.module.scss';
import TruncatedText from './TruncatedText';

interface AnnotationLinkProps {
  link: string;
}

const AnnotationLink = ({ link }: AnnotationLinkProps) => {
  const shortenedLink = link.replace(/^https?:\/\/(www\.)?/, '');

  return (
    <div className={styles.container}>
      <SVGIcon size={14} className={styles.icon}>
        {informationIcon}
      </SVGIcon>
      <a
        href={link}
        className={styles.link}
        rel="noopener noreferrer"
        target="_blank"
      >
        <TruncatedText keepLast={8}>{shortenedLink}</TruncatedText>
      </a>
    </div>
  );
};

export default AnnotationLink;
